var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownArrowUpBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "11px",
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Down_Arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text-dropdown:active",
    transform: "translate(-599.000000, -45.000000)",
    fill: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.486486,55.6842105 C608.291892,55.8947368 608.048649,56 607.805405,56 C607.562162,56 607.318919,55.8947368 607.124324,55.6842105 L599.291892,47.2105263 C598.902703,46.7894737 598.902703,46.1578947 599.291892,45.7368421 C599.681081,45.3157895 600.264865,45.3157895 600.654054,45.7368421 L607.805405,53.4736842 L615.345946,45.3157895 C615.735135,44.8947368 616.318919,44.8947368 616.708108,45.3157895 C617.097297,45.6842105 617.097297,46.3684211 616.708108,46.7894737 L608.486486,55.6842105 Z",
    id: "Down_Arrow",
    transform: "translate(608.000000, 50.500000) scale(1, -1) translate(-608.000000, -50.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowUpBlack);
export default __webpack_public_path__ + "static/media/dropdown-arrow-up-black.d7b29d473ba44b70a50eac7bee6d1304.svg";
export { ForwardRef as ReactComponent };